import { useForm } from "react-hook-form";
import { OBJECT_NAME_RULE, OBJECT_DESCRIPTION_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";
import DomainRequestModel from "../../../models/company/domain/request/DomainRequestModel";

interface DomainProps {
    objDomain: DomainRequestModel;
    actionType: string;
    onCloseDomain: () => void;
    onDomainSave: (objDomain: DomainRequestModel) => void;
}

const DomainCreateComponent = (props: DomainProps) => {
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<DomainRequestModel>({
        mode: "onChange",
        defaultValues: props.objDomain
    });

    const onSubmit = (formData: DomainRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onDomainSave(formData);
    }

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.domainName}>
                        <TextField label="Domain Name" size="small" {...register("domainName", OBJECT_NAME_RULE)} error={!!errors.domainName}
                            helperText={errors.domainName?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.description}>
                        <TextField label="Description" multiline rows={3} size="small"
                            {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end m-t-sm">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseDomain}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default DomainCreateComponent;